export default __webpack_public_path__ + "static/Mattress-Plush-7bcf3b3c24cb0d7166158a9a32c89887.gif";